import { render, staticRenderFns } from "./Home__Slide--Vimeo.vue?vue&type=template&id=354eb62e&lang=pug&"
import script from "./Home__Slide--Vimeo.vue?vue&type=script&lang=js&"
export * from "./Home__Slide--Vimeo.vue?vue&type=script&lang=js&"
import style0 from "./Home__Slide--Vimeo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports